<template>
    <b-card>
        <!-- STOCK-2875 Faz 10: İçerik yazı boyutu — kullanıcı seçimi (localStorage, cihaz bazlı) -->
        <b-form-group :label="$t('account.font_size')">
            <b-form-radio-group v-model="fontSize" stacked @change="applyFontSize">
                <b-form-radio class="mb-1" value="14">{{ $t('account.font_small') }}</b-form-radio>
                <b-form-radio class="mb-1" value="16">{{ $t('account.font_normal') }}</b-form-radio>
                <b-form-radio value="18">{{ $t('account.font_large') }}</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <!-- STOCK-2875 Faz 10: Windows ekran ölçeğini (%125/%150) yok say — UI'yi %100 gibi göster (CSS zoom). Opt-in. -->
        <b-form-group :label="$t('account.display_scale')" class="mt-2">
            <b-form-checkbox v-model="ignoreOsScale" switch @change="applyOsScale">
                {{ $t('account.ignore_os_scale') }}
            </b-form-checkbox>
        </b-form-group>
    </b-card>
</template>

<script>
export default {
    data() {
        return {
            fontSize: localStorage.getItem('contentFontSize') || '16',
            ignoreOsScale: localStorage.getItem('ignoreOsScale') === 'true'
        }
    },
    methods: {
        applyFontSize(val) {
            localStorage.setItem('contentFontSize', val)
            document.documentElement.style.fontSize = val + 'px'
        },
        // Windows ölçeğini yok say: CSS zoom = 1/devicePixelRatio ile içeriği fiziksel %100'e getir.
        applyOsScale(val) {
            localStorage.setItem('ignoreOsScale', val ? 'true' : 'false')
            document.body.style.zoom = val ? (1 / window.devicePixelRatio) : ''
        }
    }
}
</script>
